<template>
  <div>
    <div class="level mgb-2px">
      <div class="level-left" v-if="!isDetail">
        <div class="columns">
          <div class="column">
            <selecteur-action
              @handleAction="manageActions"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="facesSelectionnees"
            ></selecteur-action>
          </div>
        </div>
      </div>
      <div class="level-left" v-else>
      </div>
      <div class="level-right">
        <exportExcelButton
          class="mgr-2"
          :perm="permissions.exporter"
          :action="exporter"/>
        <a
          v-if="!isDetail"
          class="button is-addOrEdit is-pulled-right mgr-2"
          @click="handleDuplicateView">
          {{ $t('general.button.dupliquerSelection') }}
        </a>
        <parametrage-table
          reference-table="tableListeFacesBaseSelected">
        </parametrage-table>
      </div>
    </div>
    <div class="mg-auto column is-6 has-text-centered">
      {{ countFacesFilterd }}
    </div>
    <div class="overflow-auto height-500 column is-12" if="mountedLoad"
         :class="[
               { 'dispo': filtres.dispo === 'true' },
               { 'nonDispo': filtres.dispo === 'false' },
             ]">
      <v-client-table :data=filteredFacesList :columns="columns" :options="options"
        ref="tableListeFacesBaseSelected" @filter="changeFilter"
        class="is-marginless vueTableSelectionFaces">
        <template slot='afterTable'>
          <table-items-in-view :perPage="resultPerPage"
            class="is-pulled-right"
            @input="$refs['tableListeFacesBaseSelected'].setLimit($event)" />
                      </template>
        <div slot="selectedForActionGroupee" slot-scope="props">
          <b-checkbox v-model="props.row.selectedForActionGroupee"
                      :disabled="isDetail"
                      @input="selectItemForActionGroupee(props.row)">
          </b-checkbox>
        </div>
        <div slot="selected" slot-scope="props">
          <b-tooltip :label="$t('ajoutDevis.popUpSelectFace.faceNonCom')"
            :active="props.row.nonCommercialisable"
            position="is-right">
            <button
                  class="ripple button grosseCase"
                  :class="getColorIconCart(props.row)"
                  :disabled="isDisabled(props.row)"
                  @click="selectItem(props.row)">
                <b-icon icon="cart"></b-icon>
            </button>
          </b-tooltip>
        </div>
        <div slot="dispo" slot-scope="props">
          <b-tooltip
            class="width-100percent"
            :label="props.row.messageIndisponibilite"
            :active="!!props.row.messageIndisponibilite"
            size="is-large"
            position="is-right"
            multilined>
            <div
              class="colonneDispo mg-auto grosseCase"
              :class="[
                {'has-background-danger' : !props.row.dispo},
                {'has-background-success' : props.row.dispo},
              ]">
            </div>
          </b-tooltip>
        </div>
        <div slot="reference" slot-scope="props">
          <router-link-blank :to="{ name: 'c.bodac.catalogue-face',
              params: { id: props.row.produitId } }"
                             :message="props.row.reference">
          </router-link-blank>
        </div>
        <template slot="disposition" slot-scope="props">
          <b-tooltip :label="props.row.disposition" position="is-top">
            <div class="max-width-110 ellipsis">
              {{ props.row.disposition }}
            </div>
          </b-tooltip>
        </template>
        <div slot="adresse" slot-scope="props">
          {{ props.row.adresse | adresse}}
        </div>
        <div slot="ville" slot-scope="props">
          {{ props.row.ville }}
        </div>
        <div slot="formatAfficheId" slot-scope="props" class="link">
          <router-link-blank v-if="props.row.formatAfficheId"
            :to="{
              name: 'c.bodac.format_affiche',
              params: { id: props.row.formatAfficheId }}"
            class="lien"
            :message="getFormatAfficheCode(props.row.formatAfficheId)">
          </router-link-blank>
        </div>
        <div slot="reseauFaceTags" slot-scope="props">
          <tag-list :listes="getListeTags(props.row.reseauFaceTags)"/>
        </div>
        <div slot="codePostal" slot-scope="props">
          {{ props.row.codePostal }}
        </div>
        <div slot="instructionPose" slot-scope="props" v-if="isDetail">
          {{ props.row.instructionPose }}
        </div>
        <div slot="instructionPose" slot-scope="props" v-else>
          <b-input v-model="props.row.instructionPose"
              @input="setInstructionPose(props.row)"></b-input>
        </div>
        <div slot="affecteLogistiquement" slot-scope="props">
          <div v-if="displayLogistique(props.row)" class="has-text-centered">
            <b-tooltip :active="!props.row.affecteLogistiquement"
                  :label="getDetailIndispo(props.row)" position="is-left">
              <b-icon :icon="props.row.affecteLogistiquement ? 'check-circle' : 'close-circle'"
                      size="mdi-24px"
                      :type="props.row.affecteLogistiquement ? 'is-success' : 'is-danger'">
              </b-icon>
            </b-tooltip>
          </div>
        </div>
      </v-client-table>
    </div>
    <b-modal v-model="openPopUpInstructionPose" has-modal-card class="modal">
      <pop-up-instruction-pose
        @close="openPopUpInstructionPose = false"
        @addInstructionsPose="addInstructionsPose">
      </pop-up-instruction-pose>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  RESULTS_PER_PAGE_500,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import exportListeFacesSelectInVenteTempoToExcel
  from '@/services/excel/exportFaceSelectInVenteTempo/exportListeFacesSelectInVenteTempoToExcel';
import messageErreur from '@/services/general/messageErreur';
import { columnsSplice } from '@/services/general/columns';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_MASS_EDITION } from '@/configuration/general/actionsConf';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import popUpInstructionPose from '@/components/devisCommandeFacture/facesSelectInReseauTempo/popupIntructionPose';
import tableItemsInView from '@/components/general/TableItemsInView';
import parametrageTable from '@/components/general/parametrageTable';
import tagList from '@/components/general/tagList';
import * as typesParametres from '@/store/modules/parametres-mutation-type';

const TableUserParam = createNamespacedHelpers('tableUserParam');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    listeFacesBase: {
      type: Array,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: true,
    },
    duplicateView: {
      type: Boolean,
      default: false,
    },
    displayColumnLogistique: {
      type: Boolean,
      required: true,
    },
    ligneSelect: {
      type: Object,
      required: true,
    },
    inAffectation: {
      type: Boolean,
      required: false,
      default: false,
    },
    permissions: {
      type: Object,
      required: true,
    },
  },
  components: {
    tagList,
    routerLinkBlank,
    selecteurAction,
    popUpInstructionPose,
    exportExcelButton,
    parametrageTable,
    tableItemsInView,
  },
  data() {
    return {
      mountedLoad: false,
      filtres: {
        dispo: '',
        codePanneau: null,
        reference: null,
        formatAfficheId: null,
        format: null,
        adresse: null,
        ville: null,
        restriction: null,
        affecteLogistiquement: null,
        codePostal: null,
        selected: null,
        instructionPose: null,
        disposition: null,
        reseauFaceTags: '',
      },
      constantes: {
        RESULTS_PER_PAGE_500: RESULTS_PER_PAGE_500,
      },
      resultPerPage: RESULTS_PER_PAGE_500,
      actions: [
        {
          action: ACTION_MASS_EDITION, translation: 'ajoutDevis.popUpSelectFace.actions.ajouterIntructionPose',
        },
      ],
      facesSelectionnees: false,
      openPopUpInstructionPose: false,
    };
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
  computed: {
    ...TableUserParam.mapGetters({
      tableUserParam: 'tableUserParam',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    iconSelectTotal() {
      if (this.isDetail) return '';
      return 'cart';
    },
    iconSelectTotalForActionGroupee() {
      if (this.isDetail) return '';
      if (this.allFaceSelectedForActionGroupee) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allFaceSelected() {
      return this.filteredFacesList.filter((face) => {
        return !face.nonCommercialisable;
      }).length === this.listeFacesBaseSelected.length
        && this.filteredFacesList.filter((face) => {
          return !face.nonCommercialisable;
        }).length > 0;
    },
    allFilteredData() {
      if (this.mountedLoad) {
        return this.$refs?.tableListeFacesBaseSelected?.$refs?.table?.allFilteredData;
      }
      return [];
    },
    allFaceSelectedForActionGroupee() {
      return this.filteredFacesList.length === this.listeFacesBaseSelectedForActionGroupee.length
        && this.filteredFacesList.length > 0;
    },
    listeFacesBaseSelected() {
      return this.filteredFacesList.filter((face) => { return face.selected; });
    },
    listeFacesBaseSelectedForActionGroupee() {
      return this.filteredFacesList.filter((face) => { return face.selectedForActionGroupee; });
    },
    affectationLogistiqueAlreadyDone() {
      return this.listeFacesBase.some((face) => { return face.affecteLogistiquement; });
    },
    initFilters() {
      if (this.inAffectation || this.listeFacesBase.find((f) => f.selected)) {
        return { dispo: '', selected: 'true' };
      }
      return { dispo: 'true' };
    },
    formatsAffiches() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.formatAffiche);
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          codePanneau: this.$t('ajoutDevis.popUpSelectFace.tab.panneau'),
          dispo: '',
          reference: this.$t('ajoutDevis.popUpSelectFace.tab.face'),
          formatAfficheId: this.$t('ajoutDevis.popUpSelectFace.tab.formatAffiche'),
          format: this.$t('ajoutDevis.popUpSelectFace.tab.format'),
          materielType: this.$t('ajoutDevis.popUpSelectFace.tab.materielType'),
          adresse: this.$t('ajoutDevis.popUpSelectFace.tab.adresse'),
          ville: this.$t('ajoutDevis.popUpSelectFace.tab.ville'),
          reseauFaceTags: this.$t('ajoutDevis.popUpSelectFace.tab.ReseauFaceTags'),
          restriction: this.$t('ajoutDevis.popUpSelectFace.tab.restriction'),
          affecteLogistiquement: this.$t('ajoutDevis.popUpSelectFace.tab.logistique'),
          codePostal: this.$t('ajoutDevis.popUpSelectFace.tab.codePostal'),
          instructionPose: this.$t('ajoutDevis.popUpSelectFace.tab.instructionPose'),
          disposition: this.$t('ajoutDevis.popUpSelectFace.tab.disposition'),
          selectedForActionGroupee: (h) => {
            return h(
              'a', {
                attrs: {
                  class: this.isDetail ? 'pointer-events-none' : 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAllForActionGroupee();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotalForActionGroupee,
                  },
                }),
              ],
            );
          },
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: this.isDetail ? 'pointer-events-none' : 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                    class: this.allFaceSelected ? 'ripple button is-success grosseCase' : 'ripple button is-primary grosseCase',
                    type: 'is-white',
                  },
                }),
              ],
            );
          },
        },
        filterable: this.getFilterable,
        filterByColumn: true,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        initFilters: this.initFilters,
        listColumns: {
          selected: [
            {
              id: true,
              text: this.$i18n.t('ajoutDevis.popUpSelectFace.select'),
            },
            {
              id: false,
              text: this.$i18n.t('ajoutDevis.popUpSelectFace.nonSelect'),
            },
          ],
          dispo: [
            {
              id: true,
              text: this.$i18n.t('ajoutDevis.popUpSelectFace.dispo'),
            },
            {
              id: false,
              text: this.$i18n.t('ajoutDevis.popUpSelectFace.nonDispo'),
            },
          ],
          affecteLogistiquement: [
            {
              id: true,
              text: this.$i18n.t('ajoutDevis.popUpSelectFace.affecte'),
            },
            {
              id: false,
              text: this.$i18n.t('ajoutDevis.popUpSelectFace.nonAffecte'),
            },
          ],
          formatAfficheId: this.formatsAffiches.map(t => ({
            id: t.id,
            text: t.code,
          })),
        },
        texts: texts,
        filterAlgorithm: {
          dispo(row, query) {
            return row.dispo.toString() === query;
          },
        },
        columnsClasses: {
          selected: 'colonneSelected',
          dispo: 'colonneSelected',
          reference: 'is-pre',
          codePanneau: 'is-pre',
          format: 'colonneMinWidth-100px',
          materielType: 'colonneMinWidth-100px',
          reseauFaceTags: 'min-width-300',
          restriction: 'is-min-width-500',
          affecteLogistiquement: 'min-width-130',
          instructionPose: 'is-min-width-240',
          adresse: 'is-min-width-240',
          ville: 'is-min-width-240',
          selectedForActionGroupee: 'colonneSelected',
        },
        sortable: ['codePanneau', 'reference', 'formatAfficheId', 'format', 'materielType', 'adresse', 'ville', 'reseauFaceTags', 'restriction', 'affecteLogistiquement', 'codePostal', 'instructionPose', 'disposition'],
      };
    },
    columns() {
      const columns = ['selectedForActionGroupee', 'selected', 'dispo', 'reference', 'codePanneau', 'formatAfficheId', 'format', 'materielType', 'disposition', 'adresse', 'codePostal', 'ville', 'reseauFaceTags', 'restriction', 'instructionPose'];
      if (this.displayColumnLogistique) columns.push('affecteLogistiquement');
      if (this.isDetail) columnsSplice(columns, 'selectedForActionGroupee');
      if (this.inAffectation) {
        columnsSplice(columns, 'selected');
        columnsSplice(columns, 'dispo');
      }
      if (!this.moduleLogistiqueImpression) {
        columnsSplice(columns, 'formatAfficheId');
      }
      return columns;
    },
    filteredFacesList() {
      return this.listeFacesBase.filter((face) => {
        let containFilter = true;
        const keys = Object.keys(this.filtres);
        keys.forEach((key) => {
          if (this.filtres[key] && key !== 'reseauFaceTags' && key !== 'adresse') {
            if (!face[key]?.toString().toLowerCase()
              .includes(this.filtres[key].toLowerCase())) containFilter = false;
          }

          if (this.filtres[key] && key === 'reseauFaceTags') {
            const reseauTags = Array.isArray(face.reseauFaceTags) ? face.reseauFaceTags : [];
            const tagMatches = reseauTags.some(tagObj => {
              const libelle = tagObj?.tag?.libelle || '';
              return libelle.toLowerCase().includes(this.filtres[key].toLowerCase());
            });

            if (!tagMatches) containFilter = false;
          }

          if (this.filtres[key] && key === 'adresse') {
            const filterValue = this.filtres[key].toLowerCase();
            if (!face[key]?.toString().toLowerCase().includes(filterValue)
              && !adressFullStringGetter(face[key], true)?.toLowerCase().includes(filterValue)) {
              containFilter = false;
            }
          }
        });
        return containFilter;
      });
    },
    countFacesFilterd() {
      if (this.allFilteredData.length > 0) return this.allFilteredData.length + this.$i18n.t('ajoutDevis.popUpSelectFace.countFilteredFace');
      return this.$i18n.t('ajoutDevis.popUpSelectFace.countFilteredFaceNotFound');
    },
    getFilterable() {
      const columnsFiltered = ['selected', 'dispo', 'codePanneau', 'reference', 'formatAfficheId', 'format', 'materielType', 'reseauFaceTags', 'adresse', 'ville', 'restriction', 'codePostal', 'instructionPose', 'disposition'];
      if (this.displayColumnLogistique) columnsFiltered.push('affecteLogistiquement');
      if (!this.moduleLogistiqueImpression) {
        columnsSplice(columnsFiltered, 'formatAfficheId');
      }
      return columnsFiltered;
    },
    moduleLogistiqueImpression() {
      const { moduleLogistiqueImpression } = typesParametres.PARAMETRES_INTERNE_KEYS;
      return this.parametresInterne(moduleLogistiqueImpression.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getDetailIndispo(ligne) {
      if (ligne.affecteLogistiquement) return '';
      if (!ligne.actif) {
        return this.$i18n.t('ajoutDevis.popUpSelectFace.indispo.inactif');
      }
      if (ligne.autreAffectationLogistique == null) {
        if (!ligne.aPatrimoine) {
          return this.$i18n.t('ajoutDevis.popUpSelectFace.indispo.sansPatrimoine');
        }
        return this.$i18n.t('ajoutDevis.popUpSelectFace.indispo.libre');
      }
      return this.$i18n.t('ajoutDevis.popUpSelectFace.indispo.dejaPris', { visuel: ligne.autreAffectationLogistique.affectationLogistiqueLigneCommandeLibelle });
    },
    exporter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const info = {
          codeReseau: this.ligneSelect.produit.reference,
          libelle: this.ligneSelect.produit.libelle,
          anneeSemaine: this.ligneSelect.ligneReseau.anneeSemaine,
          affectationLogistiqueAlreadyDone: this.affectationLogistiqueAlreadyDone,
          displayColumnLogistique: this.displayColumnLogistique,
          isDetail: this.isDetail,
          jourDepart: this.ligneSelect.ligneReseau.jourDepart,
        };
        exportListeFacesSelectInVenteTempoToExcel(this.filteredFacesList, this.$i18n, info);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('exportExcelFaceSelect.messages.excelExportError'));
        loadingComponent.close();
        throw e;
      }
    },
    changeFilter(filter) {
      this.filtres[filter.name] = filter.value;
    },
    displayLogistique(ligne) {
      return (this.affectationLogistiqueAlreadyDone
        && (ligne.selected || ligne.affecteLogistiquement));
    },
    selectAll() {
      const selected = !this.allFaceSelected;
      this.filteredFacesList.filter((face) => {
        return !face.nonCommercialisable;
      }).forEach((face) => {
        face.selected = selected;
      });
    },
    selectAllForActionGroupee() {
      const selected = !this.allFaceSelectedForActionGroupee;
      this.filteredFacesList.forEach((face) => {
        face.selectedForActionGroupee = selected;
      });
      this.facesSelectionnees = this.allFaceSelectedForActionGroupee;
    },
    selectItem(item) {
      const faceFind = this.listeFacesBase.find((face) => {
        return face.produitId === item.produitId;
      });
      if (faceFind) faceFind.selected = !item.selected;
    },
    getColorIconCart(item) {
      if (item.selected) return 'is-success';
      return 'is-primary';
    },
    getListeTags(tags) {
      if (!tags.length) return [];
      return tags.map(t => t.tag);
    },
    selectItemForActionGroupee(item) {
      const faceFind = this.listeFacesBase.find((face) => {
        return face.produitId === item.produitId;
      });
      if (faceFind) faceFind.selectedForActionGroupee = item.selectedForActionGroupee;
      this.facesSelectionnees = faceFind.selectedForActionGroupee;
    },
    manageActions(action) {
      switch (action) {
        case ACTION_MASS_EDITION:
          this.openPopUpInstructionPose = true;
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFace.errors.noActionSelect'));
          break;
      }
    },
    addInstructionsPose(instructionPose) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.listeFacesBase.filter((face) => {
          return face.selectedForActionGroupee;
        }).forEach((face) => {
          face.instructionPose = instructionPose;
        });
        this.openPopUpInstructionPose = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        throw e;
      }
    },
    setInstructionPose(face) {
      this.listeFacesBase.filter((el) => {
        return el.produitId === face.produitId;
      }).forEach((el) => {
        el.instructionPose = face.instructionPose;
      });
    },
    isDisabled(row) {
      return (row.nonCommercialisable && !row.selected) || this.isDetail;
    },
    handleDuplicateView() {
      this.$emit('handleDuplicateView');
    },
    getFormatAfficheCode(formatAfficheId) {
      return this.formatsAffiches.find(f => f.id === formatAfficheId)?.code || '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key,
      ]);
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.formatAffiche]);
      this.resultPerPage = this.tableUserParam.tableListeFacesBaseSelected?.nbResultatParPage
        || this.constantes.RESULTS_PER_PAGE_500;
      if (this.listeFacesBaseSelected.length === 0) {
        this.filtres.dispo = 'true';
      }
      this.facesSelectionnees = this.listeFacesBase.filter((face) => {
        return face.selectedForActionGroupee;
      }).length > 0;
      this.mountedLoad = true;
    } catch (err) {
      messageErreur(this.$i18n);
      throw err;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
